export const udpTrackingCreateImpressionId = (): string => crypto.randomUUID()
